import { useState } from 'react';

import { Button, TooltipNewIcon, Typography, useModal } from '@libs/components';

import { useTranslation } from 'src/hooks';

import {
  ContentContainer,
  DescriptionWrapper,
  ToolTipIconWrapper,
} from './styles';

type InfoToolTipProps = {
  text?: string;
};
const InfoToolTip: React.FC<InfoToolTipProps> = ({ text }) => {
  const { t } = useTranslation();

  const [isToolTipVisible, setIsToolTipVisible] = useState(false);

  const handleCloseModal = () => {
    setIsToolTipVisible(false);
  };
  const { Dialog, openModal, closeModal } = useModal(handleCloseModal);

  const handleToolTipClick = () => {
    if (isToolTipVisible) {
      closeModal();
    } else {
      openModal();
      setIsToolTipVisible(true);
    }
  };

  return (
    <>
      <ToolTipIconWrapper onClick={handleToolTipClick}>
        <TooltipNewIcon height={20} width={20} />
      </ToolTipIconWrapper>

      <Dialog title="" shouldHideHeaderBorder headerBackground="transparent">
        <ContentContainer>
          <DescriptionWrapper>
            <Typography type="subHeadline" fontFamily="primaryMedium">
              {text}
            </Typography>
          </DescriptionWrapper>

          <Button
            size="lg"
            title={t('common_close')}
            onClick={closeModal}
            buttonType="secondary"
          />
        </ContentContainer>
      </Dialog>
    </>
  );
};

export default InfoToolTip;
